'use client';

import { useState } from 'react';

import type { Icon } from '@personly/libs-types';
import { InputIcon } from '@personly/libs-widgets';
import { useValidators } from '@personly/libs-providers';

import { usePasswords } from '@/providers/passwords';

interface Props {
  id: string;
  placeholder: string;
  label: string;
  enableInvalid?: boolean;
  visibilityIcons: Icon[];
}

const RegisterPassword = ({
  id,
  placeholder,
  label,
  enableInvalid = true,
  visibilityIcons,
}: Props) => {
  const { password, setPassword } = usePasswords();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { validate } = useValidators();

  const invalid =
    enableInvalid && password.length > 0 && !validate('PASSWORD', password);

  const visibilityIcon = visibilityIcons.find(
    (icon) => icon.flags.isSelected === passwordVisible
  );

  return (
    <InputIcon
      icon={visibilityIcon}
      id={id}
      invalid={invalid}
      label={label}
      name="password"
      onChange={(e) => setPassword(e.target.value)}
      onClick={() => setPasswordVisible(!passwordVisible)}
      placeholder={placeholder}
      type={passwordVisible ? 'text' : 'password'}
      value={password}
    />
  );
};

export default RegisterPassword;
